<template>
  <div class="info-card w-100 px-2 py-1 my-1">
    <div class="d-flex flex-row justify-content-between">
      <h6
        style="width: fit-content; padding: 4px 6px"
        class="bg-info rounded mb-1 text-white font-weight-bold"
      >
        {{ label }}
      </h6>
      <h6 v-if="tooltip">
        <feather-icon
          size="20"
          icon="InfoIcon"
          v-b-tooltip.hover.v-dark
          :title="tooltip"
          variant="outline-dark"
          style="cursor: pointer"
        />
      </h6>
    </div>
    <div style="white-space: pre-line">
      <span v-if="typeof value === 'string' && value.includes('<')" v-html="value"></span>
      <span v-else>{{ value }}</span>
    </div>

    <hr />
  </div>
</template>

<script>
import { VBTooltip } from "bootstrap-vue";
export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    label: String,
    value: String | Number,
    tooltip: String,
  },
};
</script>
